module.exports = __webpack_public_path__ + "media/images/grey_logos/forbes-98f7a3ae18495c200cae89acd8f10cf7.svg";